import { useMemo } from 'react';
import { useUtComparisonElecStore } from '../store/useUtComparisonElecStore';

const SUB_TAGS = [
  '차단기변경',
  'Line변경',
  '위치변경',
  'Qty변경',
  'Capacity변경',
  'DF변경',
  'ConnType변경',
];

/**
 * 요약 카드 — 전체/일치/변경(세부)/추가/삭제.
 *
 * 다른 영역과 달리 섹션 제목·접기를 두지 않는다(SectionBox 미사용) —
 * 화면을 열자마자 눈에 들어와야 하는 지표라 상시 노출한다.
 */
const ElecSummaryCards = () => {
  const diffRows = useUtComparisonElecStore((s) => s.diffRows);

  const summary = useMemo(() => {
    const rows = diffRows ?? [];
    const cnt = { same: 0, chg: 0, add: 0, del: 0 };
    const sub: Record<string, number> = {};
    for (const tag of SUB_TAGS) sub[tag] = 0;
    for (const r of rows) {
      if (r.difTpCd === 'SAME') cnt.same += 1;
      else if (r.difTpCd === 'ADD') cnt.add += 1;
      else if (r.difTpCd === 'DEL') cnt.del += 1;
      else {
        cnt.chg += 1;
        for (const tag of SUB_TAGS) if (r.difTpCtn.includes(tag)) sub[tag] += 1;
      }
    }
    const subNote = SUB_TAGS.filter((t) => sub[t] > 0)
      .map((t) => `${t}:${sub[t]}건`)
      .join(' / ');
    return { total: rows.length, ...cnt, subNote };
  }, [diffRows]);

  if (!diffRows) return null;

  return (
    <div className="summary-grid">
      <div className="scard c-total">
        <div className="n">{summary.total}</div>
        <div className="l">전체</div>
      </div>
      <div className="scard c-match">
        <div className="n">{summary.same}</div>
        <div className="l">일치</div>
      </div>
      <div className="scard c-chg">
        <div className="n">{summary.chg}</div>
        <div className="l">변경</div>
        {summary.subNote && <div className="sub">{summary.subNote}</div>}
      </div>
      <div className="scard c-add">
        <div className="n">{summary.add}</div>
        <div className="l">추가(신규)</div>
      </div>
      <div className="scard c-del">
        <div className="n">{summary.del}</div>
        <div className="l">삭제</div>
      </div>
    </div>
  );
};

export default ElecSummaryCards;
